import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import qs from "qs";
import VueCookie from "vue-cookie";
import router from "../../router";

Vue.use(VueCookie);
Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.prototype.qs = qs;

export default {
  state: {
    subscription: {},
    orderErrorVisible: false,
  },
  mutations: {
    assignSubscription: (state, payload) => {
      state.customerData.country = payload.country_id;
      state.subscription = payload;
    },
    assignOrderErrorVisible: (state, payload) => {
      state.orderErrorVisible = payload;
    },
  },
  getters: {},
  actions: {
    getSubscription: ({ commit }, payload) => {
      //TODO: Exists check
      return axios({
        cancelToken: getcancelToken(payload),
        method: "post",
        data: {
          action: "get_subscription",
          customer_id: router.history.current.query.customer_id,
          order_id: router.history.current.query.order_id,
          subscription_access_token:
            router.history.current.query.subscription_access_token,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          commit("assignSubscription", response.data.subscription);
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
    createSubscriptionOnRedirect: ({ commit, dispatch }, payload) => {
      return axios({
        cancelToken: getcancelToken(payload),
        method: "post",
        data: {
          action: "create_subscription_on_redirect",
          redirect_result: router.history.current.query.redirectResult,
          customer_id: router.history.current.query.customer_id,
          order_id: router.history.current.query.order_id,
          subscription_access_token:
            router.history.current.query.subscription_access_token,
          email: router.history.current.query.email,
          company: router.history.current.query.company,
          firstname: router.history.current.query.firstname,
          lastname: router.history.current.query.lastname,
          street: router.history.current.query.street,
          house_number: router.history.current.query.house_number,
          zip: router.history.current.query.zip,
          city: router.history.current.query.city,
          country_id: router.history.current.query.country_id,
          country_name: router.history.current.query.country_name,
          subscription_payment_type_id:
            router.history.current.query.subscription_payment_type_id,
          vat_id: router.history.current.query.vat_id,
          value_without_tax: router.history.current.query.value_without_tax,
          subscription_type_name:
            router.history.current.query.subscription_type_name,
          subscription_type_name_german:
            router.history.current.query.subscription_type_name_german,
          tax: router.history.current.query.tax,
          subscription_type_id:
            router.history.current.query.subscription_type_id,
          value: router.history.current.query.value,
          discount_code: router.history.current.query.discount_code,
          discount: router.history.current.query.discount,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          if (response.data.error == "PAYMENT FAILED") {
            commit("assignPaymentLoading", false);
            dispatch("changeErrorMsg", {
              msg:
                "There was an error while creating your payment. Please contact support@solar-fox.com",
              type: "negativ",
            });
            router.push(
              "/checkout/?subscription_type_id=" +
                router.history.current.query.subscription_type_id
            );
            return false;
          }
          if (response.data.error == "AUTH FAILED") {
            commit("assignPaymentLoading", false);
            dispatch("changeErrorMsg", {
              msg:
                "Your 3D authentication failed. Please try again with correct credentials.",
              type: "negativ",
            });
            router.push(
              "/checkout/?subscription_type_id=" +
                router.history.current.query.subscription_type_id
            );

            return false;
          }
          if (response.data.error == "COULD NOT CREATE CUSTOMER") {
            commit("assignPaymentLoading", false);
            dispatch("changeErrorMsg", {
              msg:
                "Could not create customer. Please contact support@solar-fox.com",
              type: "negativ",
            });
            router.push(
              "/checkout/?subscription_type_id=" +
                router.history.current.query.subscription_type_id
            );
            return false;
          }
          if (response.data.error == "COULD NOT CREATE SUBSCRIPTION") {
            commit("assignPaymentLoading", false);
            dispatch("changeErrorMsg", {
              msg:
                "Could not create subscription. Please contact support@solar-fox.com",
              type: "negativ",
            });
            router.push(
              "/checkout/?subscription_type_id=" +
                router.history.current.query.subscription_type_id
            );
            return false;
          }
          router.push(response.data.payment_details.redirect_url);
          return true;
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
    updateSubscriptionOnRedirect: ({ commit, dispatch }, payload) => {
      return axios({
        cancelToken: getcancelToken(payload),
        method: "post",
        data: {
          action: "update_subscription_on_redirect",
          redirect_result: router.history.current.query.redirectResult,
          customer_id: router.history.current.query.customer_id,
          order_id: router.history.current.query.order_id,
          subscription_access_token:
            router.history.current.query.subscription_access_token,
          email: router.history.current.query.email,
          company: router.history.current.query.company,
          firstname: router.history.current.query.firstname,
          lastname: router.history.current.query.lastname,
          street: router.history.current.query.street,
          house_number: router.history.current.query.house_number,
          zip: router.history.current.query.zip,
          city: router.history.current.query.city,
          country_id: router.history.current.query.country_id,
          country_name: router.history.current.query.country_name,
          subscription_payment_type_id:
            router.history.current.query.subscription_payment_type_id,
          vat_id: router.history.current.query.vat_id,
          value_without_tax: router.history.current.query.value_without_tax,
          subscription_type_name:
            router.history.current.query.subscription_type_name,
          subscription_type_name_german:
            router.history.current.query.subscription_type_name_german,
          tax: router.history.current.query.tax,
          subscription_type_id:
            router.history.current.query.subscription_type_id,
          value: router.history.current.query.value,
          discount_code: router.history.current.query.discount_code,
          discount: router.history.current.query.discount,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          if (response.data.error == "PAYMENT FAILED") {
            commit("assignPaymentLoading", false);
            dispatch("changeErrorMsg", {
              msg:
                "There was an error while creating your payment. Please contact support@solar-fox.com",
              type: "negativ",
            });
            router.push(
              "/subscription/payment?customer_id=" +
                router.history.current.query.customer_id +
                "&order_id=" +
                router.history.current.query.order_id +
                "&subscription_access_token=" +
                router.history.current.query.subscription_access_token
            );
            return false;
          }
          if (response.data.error == "AUTH FAILED") {
            commit("assignPaymentLoading", false);
            dispatch("changeErrorMsg", {
              msg:
                "Your 3D authentication failed. Please try again with correct credentials.",
              type: "negativ",
            });
            router.push(
              "/subscription/payment?customer_id=" +
                router.history.current.query.customer_id +
                "&order_id=" +
                router.history.current.query.order_id +
                "&subscription_access_token=" +
                router.history.current.query.subscription_access_token
            );

            return false;
          }
          if (response.data.error == "COULD NOT CREATE CUSTOMER") {
            commit("assignPaymentLoading", false);
            dispatch("changeErrorMsg", {
              msg:
                "Could not create customer. Please contact support@solar-fox.com",
              type: "negativ",
            });
            router.push(
              "/subscription/payment?customer_id=" +
                router.history.current.query.customer_id +
                "&order_id=" +
                router.history.current.query.order_id +
                "&subscription_access_token=" +
                router.history.current.query.subscription_access_token
            );
            return false;
          }
          if (response.data.error == "COULD NOT CREATE SUBSCRIPTION") {
            commit("assignPaymentLoading", false);
            dispatch("changeErrorMsg", {
              msg:
                "Could not create subscription. Please contact support@solar-fox.com",
              type: "negativ",
            });
            router.push(
              "/subscription/payment?customer_id=" +
                router.history.current.query.customer_id +
                "&order_id=" +
                router.history.current.query.order_id +
                "&subscription_access_token=" +
                router.history.current.query.subscription_access_token
            );
            return false;
          }
          if (response.data.error == "") {
            commit("assignPaymentLoading", false);
            dispatch("changeErrorMsg", {
              msg: "Your payment methode has been changed successfully.",
              type: "positiv",
            });
            router.push(
              "/subscription/payment?customer_id=" +
                router.history.current.query.customer_id +
                "&order_id=" +
                router.history.current.query.order_id +
                "&subscription_access_token=" +
                router.history.current.query.subscription_access_token
            );
            return false;
          }
          router.push(response.data.payment_details.redirect_url);
          return true;
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
  },
};

function getcancelToken(payload) {
  if (typeof payload != "undefined") {
    if (typeof payload.cancelToken != "undefined") {
      if (typeof payload.cancelToken.token != "undefined") {
        return payload.cancelToken.token;
      }
    }
  }
  return null;
}
